import PropTypes from 'prop-types'

export const FORM_PRESENTATIONS = {
  INLINE: 'inline',
  DRAWER: 'drawer'
}

export const CONTACT_ACTION_IDS = {
  PHONE: 'phone',
  MESSAGE: 'message',
  WHATSAPP: 'whatsapp'
}

const contactActionShape = PropTypes.shape({
  available: PropTypes.bool,
  iconOnlyCapable: PropTypes.bool
})

export const availableActionsPropType = PropTypes.shape({
  [CONTACT_ACTION_IDS.PHONE]: contactActionShape,
  [CONTACT_ACTION_IDS.MESSAGE]: contactActionShape,
  [CONTACT_ACTION_IDS.WHATSAPP]: contactActionShape
})

export const buyerIntentionsSelectionPropTypes = {
  selectedBuyerIntentions: PropTypes.array,
  hasFinancingIntention: PropTypes.bool
}

export const buyerIntentionsSelectionPropType = PropTypes.shape(buyerIntentionsSelectionPropTypes)

export const contactCardV2PropTypes = {
  adId: PropTypes.string,
  contractId: PropTypes.string,
  pageName: PropTypes.string,
  offerType: PropTypes.string,

  formPresentation: PropTypes.oneOf(Object.values(FORM_PRESENTATIONS)),
  pack: PropTypes.string,

  canariasBanner: PropTypes.node,

  sellerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sellerName: PropTypes.string,
  sellerLogo: PropTypes.string,
  sellerPhoto: PropTypes.string,
  location: PropTypes.string,
  ratingAverage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ratingCount: PropTypes.number,
  onShowAllRatings: PropTypes.func,
  isCanarias: PropTypes.bool,
  hasHomeDelivery: PropTypes.bool,
  isSellerBlocked: PropTypes.bool,

  phone: PropTypes.string,
  hidePhone: PropTypes.bool,
  multiprovince: PropTypes.string,
  target: PropTypes.string,
  authenticationHitInformation2: PropTypes.string,

  hasWhatsapp: PropTypes.bool,
  hasWhatsappProduct: PropTypes.bool,

  isZipCodeEnabled: PropTypes.bool,
  showTargetBuyerOptions: PropTypes.bool,
  targetBuyer: PropTypes.string,
  subscriptionCommitment: PropTypes.shape({
    totalMonths: PropTypes.number,
    monthlyPrice: PropTypes.number,
    kmIncluded: PropTypes.number,
    kmIncludedPeriod: PropTypes.string,
    targetBuyer: PropTypes.string
  }),
  enableAlertCreation: PropTypes.bool,
  alertSearch: PropTypes.object,
  enableAuthBeforeLead: PropTypes.bool,
  userData: PropTypes.object,

  isDrawerOpen: PropTypes.bool,
  onDrawerOpenChange: PropTypes.func,

  onAlertCreated: PropTypes.func,
  onContact: PropTypes.func,
  onLeadError: PropTypes.func,
  onLeadPhoneCall: PropTypes.func,
  onOpenDrawer: PropTypes.func,
  onSendMessageClick: PropTypes.func,
  onWhatsappError: PropTypes.func,
  onSubmitError: PropTypes.func,
  onBuyerIntentionsChange: PropTypes.func,
  onTargetBuyerChange: PropTypes.func,

  extendedLeadTrackingData: PropTypes.object,
  hasCriteoEvents: PropTypes.bool,

  buyerIntentions: PropTypes.array,
  isLeadEnrichmentEnabled: PropTypes.bool,
  isVOorVNorKM0: PropTypes.bool,
  isRenting: PropTypes.bool,
  presetBuyerIntentions: PropTypes.array,
  presetMessage: PropTypes.string,

  availableActions: availableActionsPropType,
  buyerIntentionsSelection: buyerIntentionsSelectionPropType
}

export const defaultAvailableActions = {
  [CONTACT_ACTION_IDS.PHONE]: {available: false, iconOnlyCapable: true},
  [CONTACT_ACTION_IDS.MESSAGE]: {available: true, iconOnlyCapable: true},
  [CONTACT_ACTION_IDS.WHATSAPP]: {available: false}
}
